import { useTranslation } from 'react-i18next';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from '@/shared/components/ui/dialog';
import { HistoricalImportSection } from './HistoricalImportSection';

interface ImportAbsencesDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

/** "Importar" modal on the "Saldos" panel — Owner/Admin only. */
export function ImportAbsencesDialog({ open, onOpenChange }: ImportAbsencesDialogProps) {
  const { t } = useTranslation('timeOff');

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid="time-off-import-absences-dialog">
        <DialogHeader>
          <DialogTitle>{t('team.balances.importDialog.title')}</DialogTitle>
          <DialogDescription>{t('team.balances.importDialog.description')}</DialogDescription>
        </DialogHeader>
        <HistoricalImportSection
          onSuccess={() => onOpenChange(false)}
          onCancel={() => onOpenChange(false)}
        />
      </DialogContent>
    </Dialog>
  );
}
